export const Interes_item = [
    {
        'nombre': 'CGCA 2008',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2008.pdf',
        
    },
    {
        'nombre': 'CGCA 2009',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2009.pdf',
        
    },
    {
        'nombre': 'CGCA 2010',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2010.pdf',
        
    },
    {
        'nombre': 'CGCA 2011',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2011.pdf',
        
    },
    {
        'nombre': 'CGCA 2012',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2012.pdf',
        
    },
    {
        'nombre': 'CGCA 2013',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2013.pdf',
        
    },
    {
        'nombre': 'CGCA 2014',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2014.pdf',
        
    },
    {
        'nombre': 'CGCA 2015',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2015.pdf',
        
    },
    {
        'nombre': 'CGCA 2016',
        'url':'https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/INSTRUMENTOSARCHIVISTICOS/General_Archivistica/CGCA2016.pdf',
        
    },

]